import React, { Component } from "react";
import { connect } from "react-redux";

import { Spinner } from "../../Components/Spinner/Spinner";
import ChatCard from "./ChatCard";

import { closeModel } from "../../assets/Js/closeModel";
import SearchBox from "../../Components/SearchBox/SearchBox";
import { chatGroupEnum } from "../../assets/Js/chatGroupEnum";

const mapStateToProps = (state) => {
  return {
    gymData: state.gymData,
  };
};

export default connect(
  mapStateToProps,
  null
)(
  class UserList extends Component {
    constructor(props) {
      super(props);
      this.state = {
        userList: [],
        filterUser: [],
        isLoading: false,
        listOverLayIndex: null,
      };
    }

    componentDidMount() {
      const { allAthletesData } = this.props;
      const Data = this.filterName({ Data: allAthletesData });

      this.setState({
        userList: Data,
        filterUser: Data,
      });
    }

    componentDidUpdate(prevProps, newProps) {
      if (prevProps.allAthletesData !== this.props.allAthletesData) {
        const { allAthletesData } = this.props;
        const Data = this.filterName({ Data: allAthletesData });

        this.setState({
          userList: Data,
          filterUser: Data,
        });
      }
    }

    static getDerivedStateFromProps = (props, state) => {
      return {
        ...state,
        gymData: props.gymData,
      };
    };

    filterName = ({ Data }) => {
      let _data = Data.map((eachVal) => {
        return {
          ...eachVal,
          UserName: `${eachVal.FirstName} ${eachVal.LastName}`,
        };
      });

      return [..._data];
    };

    objectReArrange = (item) => {
      let data = {};
      
      data.UserName = item.UserName;
      data.UserId = item.Id;
      data.Image = item.Image;
      data.GroupType = chatGroupEnum.OneToOne;

      return data;
    };

    changeHandler = (filteredUsers) => {
      this.setState({
        filterUser: filteredUsers,
      });
    };

    handleClick = ({ userId, groupId, UserName, key, image }) => {
      this?.props?.resetModalInfo();
      closeModel(this.props.usersModalId);
      this.props.handleClick({
        userId,
        groupId,
        UserName,
        key,
        image,
        groupType: chatGroupEnum.OneToOne,
      });
      return;
    };

    createGroupHandler = () => {
      this.props?.goToNextScreen();
    };

    render() {
      return (
        <div className="contacts overflow-hidden">
          <div
            onClick={() => this.createGroupHandler()}
            className="mb-2 primaryBtn p-2 rounded d-flex align-items-center"
          >
            <i className="mdi mdi-account-multiple-plus mr-2 ml-1"></i>
            Create New Group
          </div>
          <SearchBox
            data={this.state.userList}
            propertyToLookFor="UserName"
            changeHandler={this.changeHandler}
          />
          {this?.state?.filterUser?.length > 0 ? (
            <ul className="primaryScrollBar userListContainer list-style-none pl-0 overflow-auto mt-2">
              {this.state.filterUser.map((item, key) => {
                return (
                  <ChatCard
                    userCard={true}
                    textLimit={40}
                    item={this.objectReArrange(item)}
                    key={key}
                    listOverLayIndex={this.state.listOverLayIndex}
                    handleClick={this.handleClick}
                  />
                );
              })}
            </ul>
          ) : (
            <div className="text-center mt-3">No Users Found</div>
          )}
          {this.state.isLoading && (
            <div className="mt-3">
              <Spinner />
            </div>
          )}
        </div>
      );
    }
  }
);
